<!--tools is a component of
    toolbar.vue (hidden-sm-and-down) &
    navmobile.vue (none-md-and-up)

    Includes language switch, cart & login-->
<template>
  <!-- <span> -->
  <v-container fluid class="pa-0 fill-height">
    <v-menu
      v-for="(tool, i) in itemsCombined"
      :key="i"
      class="appbartext"
      :open-on-hover="!isMobile"
      down
      offset-y
      :close-on-content-click="closeOnContentClick"
    >
      <!-- show all menu items except the language button, when there is only one language -->
      <template v-if="tool.icon && (tool.link || tool.SiteLanguages || getYesNo(tool, 'webshop'))" v-slot:activator="{ props }">

      
        <v-btn
          icon
          v-bind="props"
          height="100%"
          v-if="tool.controle"
          :href="tool.link || undefined"
        >  
        <v-icon>
            <ClientOnly v-if="getYesNo(tool, 'webshop') ">
              <CartIcon :icon="tool.icon" />
            </ClientOnly>
            <SvgIconPublic v-else :url="tool.icon" />
            </v-icon>
        </v-btn>
      </template>
      <!--hover card:language-->
      <v-list
        elevation="0"
        v-model="drawer1"
        v-if="tool.SiteLanguages"
        class="pa-2 appbaritems"
        style="background-color: white;overflow: hidden;"
        width="280px"
      >
        <v-list-item
          v-for="(subItem, index) in tool.SiteLanguages"
          :key="index"
        >
          <v-list-item-title v-if="subItem.SiteLanguageFlagIcon" >
            <button @click="changeLocale(subItem.SiteLanguageChoice)">
              <SvgIconPublic class="appbartext" :url="subItem.SiteLanguageFlagIcon"/>
              <!-- <v-img
                  class="appbartext"
                  :src="subItem.SiteLanguageFlagIcon"
                  :width="iconSize"
                /> -->
              {{ subItem.SiteLanguageTitle }}
            </button>
          </v-list-item-title>
        </v-list-item>
      </v-list>
      <!--hover card: login-->
      <v-list v-if="getYesNo(tool, 'webshop')" elevation="0" class="pa-0">
        <ClientOnly>
          <CartPopOver />
        </ClientOnly>
      </v-list>
      <!-- todo nakijken welke switch tool.Extranet ?-->
      <v-list v-if="getYesNo(tool.login) " elevation="0" class="pa-0">
        <!-- <LoginForm
          v-show="!isUserLoggedIn"
          :authDataStrings="authData"
        ></LoginForm> -->

        <v-container v-if="isLoggedIn">
          Welkom ...
          todo
          <!-- <div>
            {{ authData.LoginWelkomBericht }}
            {{ $store.state.auth.user.name }}
          </div>
          <v-btn class="mt-2" width="100%" :to="{ path: 'auth/account' }">
            {{ authData.LoginProfielTitle }}
          </v-btn>
          <v-btn
            v-if="!runtimeConfig.public.IS_INTRANET"
            class="bg-secondary mt-2"
            width="100%"
            :to="{ path: 'auth/changePassword' }"
          >
            {{ authData.changePasswordTitle }}
          </v-btn>
          <v-btn
            class="bg-secondary mt-2"
            width="100%"
            @click.prevent="authLogout()"
          >
            {{ authData.UitloggenTitle }}
          </v-btn> -->
        </v-container>
      </v-list>
    </v-menu>
  </v-container>
  <!-- </span> -->
</template>

<script setup>
// import LoginForm from "@/components/Auth/LoginForm.vue";
import SvgIconPublic from "@/components/Base/SvgIconPublic.vue";
import CartIcon from "@/components/Cart/CartIcon.vue";
import { useSiteSettingsStore } from "../../store/siteSettings";
const runtimeConfig = useRuntimeConfig();
const dataAll = useDataAll();
const siteSettings = useSiteSettingsStore();
const drawer1 = ref(false);
const { isLoggedIn } = useUnifiedAuth()
const statisch = [];
// const authData = dataAll.getKey("authData", []);
const SiteLanguages = dataAll.getKey("SiteLanguages", []);
const config = [];
const webshop = [];

let closeOnContentClick = true // Prevent console warning in develop mode closeOnContentClick expect boolen got string
let verified = false;
let quantity = 1;



function changeLocale(locale) {
   // Reload by change of language
  if (dataAll.getDefaultLanguage() == locale.toLowerCase()) {
    window.location.href = "/";
  } else {
    window.location.href = "/" + locale.toLowerCase();
  }
}
const isMobile = computed(()=>{
  switch (useNuxtApp().$vuetify.display.mobile._object.name) {
    case "xs":
    case "sm":
      return true;
    default:
      return false;
  }   
})

const itemsCombined = computed(() => {
  if (siteSettings.length==0){
     return []
  } else {
  return [
    {
      showItem: siteSettings.IconLanguageFlagConditional,
      controle: siteSettings.IconLanguageFlagConditional,
      icon: siteSettings.IconLanguageFlag,
      altText: siteSettings.IconLanguageFlagAltText,
      SiteLanguages: SiteLanguages,
      '1': '1'
    },
    {
      showItem: siteSettings.IconMailConditional,
      controle: siteSettings.IconMailConditional,
      icon: siteSettings.IconMail, // EmailAdd SvgIcon
      altText: siteSettings.IconMailAltText,
      link: "mailto:" + siteSettings.FooterEmail,
      '2': '2'
    },
    {
      showItem: siteSettings.IconTelephoneConditional,
      controle: siteSettings.IconTelephoneConditional,
      icon: siteSettings.IconTelephone, // Phone SvgIcon
      altText: siteSettings.IconTelephoneAltText,
      link: "tel:" + siteSettings.FooterTelephone,
      '3': '3'
    },
    {
      showItem: siteSettings.IconAccountConditional,
      controle: siteSettings.IconAccountConditional,
      icon: siteSettings.IconAccount, // 'Account' SvgIcon
      altText: siteSettings.IconAccountAltText,
      login: [],
      '4': '4'
    },
    {
      // || todo true tijdelijke fix.
      showItem: true,
      controle: true,
      icon: siteSettings.IconWebshop,//'ShoppingBasket', SvgIcon
      altText: siteSettings.IconWebshopAltText,
      webshop: getYesNo(siteSettings, 'Webshop'),
      '5': '5'
    },
  ];
  }
});

</script>
